import React from 'react'

const Button = ({ cmdLabel, cmdAction, cmdName, cmdSetter, dataValues, url, headers, api, IdEmp, setTryToSave, setAbleToSave, ableToSave, ip, setShowGrid, setLoading }) => {
  return (
        <button
          name={cmdName}
          onClick={(e) => cmdAction({setter: cmdSetter, name: e.target.name, values: dataValues, url: url, headers: headers, api:api, IdEmp:IdEmp, setTryToSave: setTryToSave, setAbleToSave: setAbleToSave, ableToSave:ableToSave, ip:ip, setShowGrid:setShowGrid, setLoading:setLoading})}
          className="/inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
        >{ cmdLabel }</button>
  )
}

export default Button